import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const industryDataClassName = DataClassName.INDUSTRY
const industryEndpoint = PisaDataClassEndpoint.INDUSTRY

export function pisaIndustryDataClass(attributes: DataAttributeDefinitions) {
  return provideDataClass(industryDataClassName, {
    title: industryDataClassName,
    restApi: createPisaRestApiConfig(industryEndpoint),
    attributes,
  })
}
